import Vue from 'vue'
import Vuex from 'vuex'
import themes from '../js/themes'

/* ----------  Modules  ---------- */
import auth from './auth'
import db from './db'
import clipboard from './clipboard'
import pages from './pages'
import settings from './settings'

Vue.use(Vuex)

// Vuex state declaration
export const store = new Vuex.Store({
  strict: true,
  state: {
    navMain: true,
    navRight: false,
    navRightExtra: false,
    socketConnection: false,
    theme: localStorage.getItem('theme') || 'theme1', // 'theme1',
    themeDark: localStorage.getItem('themeDark') == 'true' ? true : false, // this is always a string
    themeSavedImages: []
  },
  mutations: {
    initialize (state) {
      var savedImages
      try {
        savedImages = JSON.parse(localStorage.getItem('themeSavedImages')) || []
      } catch (e) {
        savedImages = []
      }
      state.themeSavedImages = savedImages
    },
    openNavMain (state, val) {
      state.navMain = val
    },
    openNavRight (state, val) {
      state.navRight = val
    },
    openNavRightExtra (state, val) {
      state.navRightExtra = val
    },
    setTheme (state, {themeName, themeDark, vuetify}) {
      state.theme = themeName
      state.themeDark = themeDark
      // vuetify.theme.themes = themes[themeName].vuetifyTheme
      // vuetify.theme.setTheme(themes[themeName].vuetifyTheme)
      vuetify.theme.setTheme('light', themes[themeName].themes.light)
      vuetify.theme.setTheme('dark', themes[themeName].themes.dark)
      vuetify.theme.dark = themeDark
      localStorage.setItem('theme', themeName)
      localStorage.setItem('themeDark', themeDark)
      // vuetify.framework.theme.themes = themes[themeName].vuetifyTheme
    },
    saveBackgroundImage (state, imageUrl) {
      var savedImages
      try {
        savedImages = JSON.parse(localStorage.getItem('themeSavedImages')) || []
      } catch (e) {
        savedImages = []
      }
      if (!savedImages.includes(imageUrl)) {
        savedImages.push(imageUrl)
      }
      localStorage.setItem('themeSavedImages', JSON.stringify(savedImages))
      state.themeSavedImages = savedImages
    },
    deleteBackgroundImage (state, imageUrl) {
      var savedImages
      try {
        savedImages = JSON.parse(localStorage.getItem('themeSavedImages'))
      } catch (e) {
        savedImages = []
      }
      savedImages = savedImages.filter(item => item !== imageUrl)
      localStorage.setItem('themeSavedImages', JSON.stringify(savedImages))
      state.themeSavedImages = savedImages
    },
    SOCKET_CONNECT: (state) => {
      state.socketConnection = true
    },
    SOCKET_DISCONNECT: (state, status) => {
      state.socketConnection = false
    }
  },
  actions: {
    syncAllData: ({commit, dispatch}) => {
      return Promise.all([
        dispatch('db/currencies/fetchAll'),
        dispatch('db/currencyRates/fetchAll'),
        dispatch('settings/fetchAll')
        // dispatch('deliveries/fetchAll'),
        /* dispatch('deliveryItems/fetchAll'),
        dispatch('inventory/fetchAll'),
        dispatch('inventoryDefinitions/fetchAll'),
        dispatch('inventoryArchive/fetchAll'),
        dispatch('suppliers/fetchAll'),
        dispatch('productBuilds/fetchBuilds'),
        dispatch('productBuilds/fetchBuildItems'),
        dispatch('production/fetchAll'),
        dispatch('productionOutputs/fetchProductionOutputs'),
        dispatch('productionInputs/fetchProductionInputs'),
        dispatch('customers/fetchAll'),
        dispatch('addresses/fetchAll'),
        dispatch('sales/fetchAll'),
        dispatch('salesItems/fetchAll'),
        dispatch('users/fetchAll') */
      ])
        .then(() => {
          dispatch('db/updateDBLastSync')
        })
    }
  },
  getters: {},
  modules: {
    auth, db, clipboard, pages, settings
  }
})
